import React from "react";

type IconProps = {
  className?: string;
};

function BaseIcon({ className = "w-4 h-4", children }: React.PropsWithChildren<IconProps>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export function IconEdit2({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </BaseIcon>
  );
}

export function IconTrash2({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M3 6h18" />
      <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
      <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
      <line x1="10" x2="10" y1="11" y2="17" />
      <line x1="14" x2="14" y1="11" y2="17" />
    </BaseIcon>
  );
}

export function IconX({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M18 6 6 18" />
      <path d="m6 6 12 12" />
    </BaseIcon>
  );
}

export function IconPlus({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M5 12h14" />
      <path d="M12 5v14" />
    </BaseIcon>
  );
}

export function IconChevronRight({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="m9 18 6-6-6-6" />
    </BaseIcon>
  );
}

export function IconWallet({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1" />
      <path d="M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4" />
    </BaseIcon>
  );
}

export function IconCreditCard({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <rect width="20" height="14" x="2" y="5" rx="2" />
      <line x1="2" x2="22" y1="10" y2="10" />
    </BaseIcon>
  );
}

export function IconTag({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z" />
      <circle cx="7.5" cy="7.5" r=".5" fill="currentColor" />
    </BaseIcon>
  );
}

export function IconZap({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
    </BaseIcon>
  );
}

export function IconLock({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </BaseIcon>
  );
}

export function IconUnlock({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0 1 9.9-1" />
    </BaseIcon>
  );
}

export function IconDatabase({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <ellipse cx="12" cy="5" rx="9" ry="3" />
      <path d="M3 5V19A9 3 0 0 0 21 19V5" />
      <path d="M3 12A9 3 0 0 0 21 12" />
    </BaseIcon>
  );
}

export function IconHouse({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
      <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </BaseIcon>
  );
}

export function IconChartColumn({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M3 3v16a2 2 0 0 0 2 2h16" />
      <path d="M18 17V9" />
      <path d="M13 17V5" />
      <path d="M8 17v-3" />
    </BaseIcon>
  );
}

export function IconPieChart({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.952-8.952c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z" />
      <path d="M21.95 13a10 10 0 1 1-10.95-10.95" />
    </BaseIcon>
  );
}

export function IconPiggyBank({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z" />
      <path d="M2 9v1c0 1.1.9 2 2 2h1" />
      <path d="M16 11h.01" />
    </BaseIcon>
  );
}

export function IconTarget({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </BaseIcon>
  );
}

export function IconTrendingDown({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M16 17h6v-6" />
      <path d="m22 17-8.5-8.5-5 5L2 7" />
    </BaseIcon>
  );
}

export function IconTrendingUp({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M22 7h-6" />
      <path d="m2 17 5-5 4 4 8-8" />
    </BaseIcon>
  );
}

export function IconSave({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M15.2 3.2a1 1 0 0 1 .7.3l4.8 4.8a1 1 0 0 1 .3.7V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M17 21v-8H7v8" />
      <path d="M7 3v5h8" />
    </BaseIcon>
  );
}

export function IconLogOut({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <polyline points="16 17 21 12 16 7" />
      <line x1="21" x2="9" y1="12" y2="12" />
    </BaseIcon>
  );
}

export function IconMenu({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <line x1="4" x2="20" y1="12" y2="12" />
      <line x1="4" x2="20" y1="6" y2="6" />
      <line x1="4" x2="20" y1="18" y2="18" />
    </BaseIcon>
  );
}

export function IconSearch({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <circle cx="11" cy="11" r="7" />
      <path d="m21 21-4.3-4.3" />
    </BaseIcon>
  );
}

export function IconInfo({ className }: IconProps) {
  return (
    <BaseIcon className={className}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <circle cx="12" cy="8" r=".8" fill="currentColor" />
    </BaseIcon>
  );
}
